import './App.css';
import 'leaflet/dist/leaflet.css';
import L,{ MapContainer, Marker, Popup,Polyline,Polygon, TileLayer, Tooltip , Circle, GeoJSON} from "react-leaflet";
import { useEffect, useState } from 'react';
import singleCityData from "./data/deqan-single.json";
import cityTimeData from "./data/deqan.json";
import Loading from './reusable/Loading';
import logo from "./img/ihmk-logo.png";
import logoName from "./img/src_images_IHMK_logo.png";
import MainModal from './reusable/MainModal';
import axios from 'axios';
import { MyCustomMarker } from './reusable/MyCustomMarker';
import { AQIHEX, PM10, PM25, O3, NO2 } from './data/ihmkBrakePoints';
import { AQICalculator } from './data/calculateAqi';
import INFOICON from  './img/info.svg';
import InfoModal from './reusable/InfoModal';
import langData from './data/translations.json';

function App() {
  const [center, setCenter] = useState([42.6571639, 21.148077]);
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [timeData, setTimeData] = useState([]);
  const [parIndex, setParIndex] = useState(1);
  const [parType, setParType] = useState('PM25');
  const [hourDate, setHourDate] = useState();
  const limeOptions = { color: 'transparent', borderColor: "lime" };
  const setColor = ({ properties }) => {
    return { weight: 1 , color: "black", fillColor: "lime"};
  };

  let querry = new URLSearchParams(window.location.search);
  let parametterQuerry = querry?.get('par')?.toUpperCase();
  let langQuerry = querry?.get('lang');
  console.log('params', parametterQuerry);
  useEffect(()=>{
    if(parametterQuerry !== undefined && parametterQuerry !== 'undefined' && parametterQuerry !== null   ) {
      setParType(parametterQuerry);
    }
    if(langQuerry !== undefined && langQuerry !== 'undefined' && langQuerry !== null   ) {
      setLang(langQuerry);
    }
    
  },[parametterQuerry, langQuerry])
 

 
  // console.log('cities', cityData);
  const [ cityId, setCityId] = useState();
  const [modalName, setModalName] = useState();
  const [mapData, setMapData] = useState(null);
  const [lang, setLang] = useState(querry?.get('lang'));


//handle language change select
const langChange = (e) => {
  e.preventDefault();
  setLang(e.target.value);
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.set('lang', e.target.value);
  window.location.search = urlParams;
  // window.location.reload();
}

//handle language change on runtime
useEffect(()=>{
  const urlParams = new URLSearchParams(window.location.search);
  let myLang = urlParams.get('lang');
  // console.log('effectLang', myLang);
  setLang(myLang);
  document.documentElement.lang = myLang;
},[]);
useEffect(()=>{
  const urlParams = new URLSearchParams(window.location.search);
  let myLang = urlParams.get('lang');
  // console.log('effectLang', myLang);
  setLang(myLang);
  document.documentElement.lang = myLang;
},[lang]);

// label translation

const translateMe = (lang, key) => {
  let myData = langData.filter(data =>  data.id === key)[0][lang];
  // console.log('langData', myData);
  return myData
}

// handle time change


useEffect(()=> {
  if(mapData !== null) {
    let unixtstamp = mapData[0]?.aqiData?.list[parIndex]?.dt;
    let data = new Date( unixtstamp * 1000);
    let stringDt = data.toISOString();
    let mydata = stringDt.slice(0,16)?.replace('T', ' ');
    // let data = new Date(mapData[0].feature.aqiData.list[parIndex].dt * 1000);
    // console.log('dataaa', stringDt, data);
    setHourDate(data?.toLocaleDateString(lang, {weekday: 'long'}) + ' ' + mydata);
    // let dt = new Date(mapData?.feature[0]?. * 1000);
  }

},[parIndex]);

// api call to get forecast data
  const getMapData = async () => {
    await axios.get("https://aqkosovo.cacttus.com/forecast-api/citiesAll/all").then(response => {
      // console.log("apiData",response.data);
     setMapData(response.data);
     let unixtstamp = response.data[0]?.aqiData?.list[1]?.dt;
     let data = new Date( unixtstamp * 1000);
     let stringDt = data.toISOString();
     let mydata = stringDt.slice(0,16)?.replace('T', ' ')
     setHourDate(data?.toLocaleDateString(lang, {weekday: 'long'}) + ' ' + mydata);
     // let data = new Date(mapData[0].feature.aqiData.list[parIndex].dt * 1000);
     setLoading(false);
    //  console.log('dataaa', mydata, data?.toLocaleDateString('sq-AL', {weekday: 'long'}));
   }).catch(err => {
    console.log(err);
   }) 
   
  }

  useEffect(()=>{
    getMapData();
  },[])

// on each geoJson function
function onEachFeature(feature, layer){
  if(feature.properties){
    let fid = feature?.id?.split(".")[1];
    layer.options.color = 'gray';
    layer.options.weight = 0.7;
    layer.options.fillOpacity = 0.8;
    layer.options.dashArray = 1;
    layer.options.opacity = 1;
    layer.options.fillColor =  AQICalculator(parType, feature.aqiData.list[parIndex].components.pm2_5);
    // console.log('forEachGjson', fid, feature, layer);
  }
  layer.on({
      // mouseover: () =>  {},
      click: () =>  {
        if(parType === 'PM25') {
          layer.bindPopup("Komuna: " +  feature.properties.name + ' <br /> PM2.5: ' + feature.aqiData?.list[parIndex]?.components?.['pm2_5'] + ' µm/m³ <br /> ' + hourDate ).openPopup();
        }
        if(parType === 'PM10') {
          layer.bindPopup("Komuna: " +  feature.properties.name + ' <br /> PM10: ' + feature.aqiData?.list[parIndex]?.components?.['pm10'] + ' µm/m³ <br /> ' + hourDate ).openPopup();
        }
        if(parType === 'SO2') {
          layer.bindPopup("Komuna: " +  feature.properties.name + ' <br /> SO2: ' + feature.aqiData?.list[parIndex]?.components?.['so2'] + ' µm/m³ <br /> ' + hourDate ).openPopup();
        }
        if(parType === 'NO2') {
          layer.bindPopup("Komuna: " +  feature.properties.name + ' <br /> NO2: ' + feature.aqiData?.list[parIndex]?.components?.['no2'] + ' µm/m³ <br /> ' + hourDate ).openPopup();
        }
        if(parType === 'O3') {
          layer.bindPopup("Komuna: " +  feature.properties.name + ' <br /> O3: ' + feature.aqiData?.list[parIndex]?.components?.['o3'] + ' µm/m³ <br /> ' + hourDate ).openPopup();
        }
      }, // function
      // mouseout: () => {layer.bindPopup().closePopup()},
  //   click:  (e) => { 
  //     // layer.bindPopup("Your text or whatever 1234 " +  feature.properties.name);
      
  //       setIsOpen(true);
  //       setModalName(feature.properties.name);
  //       setTimeData(feature.aqiData);
  //       setCityId(feature.city_id);
  //        console.log('clicking', feature);

  // }
  });
  // layer.on("mouseover", function (e) {
  //   layer.bindPopup("Your text or whatever " +  feature.properties.name).openPopup();
  // });
}

  
  if (loading && mapData === null) {
    return <Loading />
  } else
  return (
    <div className="App">
  
        <div className='parameterMenu'>
          <button disabled>{translateMe(lang, "index").toUpperCase()}</button>
          <button className='text-left' style={parType === 'PM25' ? { fontWeight:'800',color: '#326bb2', borderLeft: '3px solid #326bb2'}: null} onClick={()=>{setParType('PM25'); setParIndex(1)}}>PM<sub>2.5</sub></button>
          <button className='text-left' style={parType === 'PM10' ? { fontWeight:'800',color: '#326bb2', borderLeft: '3px solid #326bb2'}: null} onClick={()=>{setParType('PM10'); setParIndex(1)}}>PM<sub>10</sub></button>
          <button className='text-left' style={parType === 'NO2' ? { fontWeight:'800',color: '#326bb2', borderLeft: '3px solid #326bb2'}: null} onClick={()=>{setParType('NO2'); setParIndex(1)}}>NO<sub>2</sub></button>
          <button className='text-left' style={parType === 'O3' ? { fontWeight:'800',color: '#326bb2', borderLeft: '3px solid #326bb2'}: null} onClick={()=>{setParType('O3') ; setParIndex(1)}}>O<sub>3</sub></button>
          <button className='text-left' style={parType === 'SO2' ? { fontWeight:'800',color: '#326bb2', borderLeft: '3px solid #326bb2'}: null} onClick={()=>{setParType('SO2'); setParIndex(1)}}>SO<sub>2</sub></button>
        </div>
        <div className='langMenu'>
          <label>{translateMe(lang, "lang").toUpperCase()}</label><br />
          <select onChange={langChange} defaultValue={lang}>
            <option value={"sq"}>Albanian</option>
            <option value={"en"}>English</option>
            <option value={"sr"}>Serbian</option>
          </select> 
        </div>
          <form className="mainTopForm" >
            <div className='row'>
              
              <div className='col-10 p-2 pr-4 pl-5'>
               <div className='row pl-1'>{hourDate && hourDate}</div>
               <div className='row'>
               {parIndex && <input type="range" onChange={(e)=> {setParIndex(e.target.valueAsNumber);}} min={1} max={mapData[0]?.aqiData?.list.length - 1} value={parIndex} />}
               </div>
              </div>
              <div className='col-2 p-2 ml-n3'>
                {/* <i className='fa fa-info-circle-alt fa-2x' /> */}
                <img src={INFOICON} alt='info'  width={'40px'} onClick={()=> setIsOpen(true)} />
              </div>
            </div>
          </form>
          <InfoModal modalName='Shaban' id='info' handleClose={()=>setIsOpen(false)} isOpen={isOpen} lang={lang} langData={langData} langFn={translateMe}/>
{/*         
        <MainModal 
        cityId={cityId} 
        timeData={timeData}
            modalName={modalName}
                        handleClose={() => { setIsOpen(false);}} isOpen={isOpen} refreshState={true} /> */}
        <div className='logo'>
          <img src={logo} />
        </div>
  
        <div className='map'>
        <MapContainer center={center} zoom={8} scrollWheelZoom={true} style={{ width: "100%", height: "100vh" }}  >
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        
          {mapData?.features?.map(el => {
            let pos = [el.lat, el.lng];
            console.log('markerData',pos);
            // <Marker position={pos} icon={MyCustomMarker} >
              // <Popup>
              //    {el.properties.name}
              // </Popup>
            //   </Marker>
            // L.marker(pos, {icon: MyCustomMarker}).addTo(map);
          })}

          {/* <Polyline pathOptions={limeOptions} positions={ mapData} /> */}
          {parIndex && parType && hourDate && <GeoJSON data={mapData} onEachFeature={onEachFeature} key={ parIndex + parType + hourDate} />}
        
          {/* <GeoJSON data={ecomp} pointToLayer={setIcon} /> */}
        </MapContainer>
        </div>

    </div>
  );
}

export default App;
